<template>
  <div>
    <form class="form-signin" role="form" @submit.prevent="onRegister">
      <div class="form-group">
        <h2>Create account</h2>
      </div>
      <div v-if="isErr.length" class="alert alert-danger">{{ isErr }}</div>
      <div class="form-group">
        <label class="control-label" for="signupName">Nickname</label>
        <input
          id="signupName"
          type="text"
          maxlength="50"
          class="form-control"
          placeholder="e.g., Joe"
          v-model="regUser.name"
        />
      </div>
      <div class="form-group">
        <label class="control-label" for="signupEmail">Email</label>
        <input
          id="signupEmail"
          type="email"
          maxlength="50"
          class="form-control"
          placeholder="e.g., joe@ezrelic.com"
          v-model="regUser.email"
        />
      </div>
      <div class="form-group">
        <label class="control-label" for="signupPassword">Password</label>
        <input
          id="signupPassword"
          type="password"
          class="form-control"
          placeholder="at least 8 characters"
          v-model="regUser.pw"
        />
      </div>
      <div class="form-group">
        <button
          @submit="onRegister"
          id="signupSubmit"
          class="btn btn-info btn-block"
          type="submit"
        >Create your account</button>
      </div>
      <hr />
      <p>
        Already have an account?
        <a>
          <router-link to="/login">
            <i class="fa fa-fw fa-lock"></i>Login
          </router-link>
        </a>
      </p>
    </form>
  </div>
</template>

<style lang="css" scoped>
</style>

<script>
import { mapState } from "vuex";
export default {
  Name: "Register",
  components: {},
  data() {
    return {
      errorMessage: null,
      regUser: {
        name: "",
        email: "",
        pw: ""
      }
    };
  },
  computed: {
    ...mapState(["signupError"]),
    isErr: function() {
      return this.signupError;
    }
  },
  methods: {
    async onRegister() {
      let store = this.$store;
      let router = this.$router;
      let name = this.regUser.name;
      let email = this.regUser.email;
      let password = this.regUser.pw;

      await store.dispatch("signup", { email, password, name });

      if (store.state.signupError == "") {
        router.push({ name: "ConfirmRegistration", params: { email: email } });
      }
    }
  }
};
</script>